// extracted by mini-css-extract-plugin
export default {"container":"DarkMode_container__QUgFP","switch":"DarkMode_switch__seuGA","slider":"DarkMode_slider__PfQ4z","round":"DarkMode_round__+g8Pj"};